import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/banner_livestream.png'
import _imports_1 from '@/assets/images/bg-top_vrjmof.jpg'
import _imports_2 from '@/assets/images/top_conbadge.jpg'
import _imports_3 from '@/assets/images/logo-vrchat_ex.png'
import _imports_4 from '@/assets/images/logo-resonite.svg'


const _withScopeId = n => (_pushScopeId("data-v-8cfd4c8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contents contents-top" }
const _hoisted_2 = { class: "banner-link-wrapper" }
const _hoisted_3 = { class: "banner-link" }
const _hoisted_4 = {
  href: "https://docs.google.com/forms/d/e/1FAIpQLSe42qPv6KSgcLezg6ove2M-FUdxm4Okxk4YkEjEwXavyWHRnQ/viewform",
  target: "_blank"
}
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "banner-link" }, [
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "https://www.twitch.tv/vr_jmof/"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "公式動画配信 / Official Livestream",
      width: "300"
    })
  ])
], -1))
const _hoisted_7 = {
  id: "theme-world",
  target: "_blank",
  href: "https://vrchat.com/home/world/wrld_4ec9ae60-6542-4249-97c9-ec555bdb9a13"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = { class: "page-flexwrap" }
const _hoisted_12 = { class: "page-image" }
const _hoisted_13 = ["alt"]
const _hoisted_14 = { class: "page-flexinner" }
const _hoisted_15 = {
  href: "https://twitter.com/karoooome",
  target: "_blank"
}
const _hoisted_16 = { class: "caution" }
const _hoisted_17 = { class: "contents contents-about_VRChat" }
const _hoisted_18 = { class: "box-wrap" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "VRChat",
  width: "245",
  height: "137.5"
}, null, -1))
const _hoisted_20 = { class: "box-inner" }
const _hoisted_21 = { class: "box-wrap" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "resonite",
  width: "245",
  height: "137.5"
}, null, -1))
const _hoisted_23 = { class: "box-inner" }
const _hoisted_24 = { class: "contents contents-about_JMoF" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TopLogo = _resolveComponent("TopLogo")!
  const _component_ContentBox = _resolveComponent("ContentBox")!
  const _component_Heading = _resolveComponent("Heading")!
  const _component_TopNews = _resolveComponent("TopNews")!
  const _component_LinkButton = _resolveComponent("LinkButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createVNode(_component_ContentBox, { class: "content-box" }, {
        default: _withCtx(() => [
          _createVNode(_component_TopLogo)
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("a", _hoisted_4, [
            _createElementVNode("img", {
              src: require('@/assets/images/banner-event.png'),
              alt: 
              _ctx.locale === 'ja'
                ? 'アバター＆ポスター募集中！'
                : 'Avatar & Poster Submissions'
            ,
              width: "300"
            }, null, 8, _hoisted_5)
          ])
        ]),
        _hoisted_6
      ]),
      _createElementVNode("a", _hoisted_7, [
        _createElementVNode("img", {
          src: 
          _ctx.locale === 'ja'
            ? require('@/assets/images/furry_ghost_hotel.png')
            : require('@/assets/images/furry_ghost_hotel_en.png')
        ,
          alt: "Furry Ghost Hotel"
        }, null, 8, _hoisted_8)
      ]),
      _createVNode(_component_ContentBox, { class: "content-box" }, {
        default: _withCtx(() => [
          _createVNode(_component_Heading, {
            class: "box-title",
            tag: "h2"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('about-vrjmof', 'title')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('about-vrjmof', 'text_1')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('about-vrjmof', 'text_2')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('about-vrjmof', 'text_3')), 1),
          _hoisted_9
        ]),
        _: 1
      }),
      _createVNode(_component_ContentBox, { class: "content-box box-news" }, {
        default: _withCtx(() => [
          _createVNode(_component_Heading, {
            class: "box-title",
            tag: "h2"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('news', 'title')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_TopNews)
        ]),
        _: 1
      }),
      _createVNode(_component_ContentBox, { class: "content-box" }, {
        default: _withCtx(() => [
          _createVNode(_component_Heading, {
            class: "box-title",
            tag: "h2"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('info-badge', 'title')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("p", null, [
            _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('info-badge', 'text_1')) + " ", 1),
            _hoisted_10,
            _createTextVNode(" " + _toDisplayString(_ctx.$props.i18n.$text('info-badge', 'text_2')), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("img", {
                src: _imports_2,
                alt: _ctx.$props.i18n.$text('info-badge', 'alt_1'),
                width: "320"
              }, null, 8, _hoisted_13)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('info-badge', 'text_3')), 1),
              _createElementVNode("p", null, [
                _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('info-badge', 'text_4')), 1),
                _createElementVNode("a", _hoisted_15, _toDisplayString(_ctx.$props.i18n.$text('info-badge', 'link_1')), 1)
              ]),
              _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.$props.i18n.$text('info-badge', 'caution_1')), 1)
            ])
          ]),
          _createVNode(_component_LinkButton, {
            href: "/downloads/VRJMoF2024_ConBadge.zip",
            "is-external": true
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('info-badge', 'link_2')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("section", _hoisted_17, [
      _createVNode(_component_ContentBox, { class: "content-box" }, {
        default: _withCtx(() => [
          _createVNode(_component_Heading, {
            class: "box-title",
            tag: "h2"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('about-vrchat', 'title')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('about-vrchat', 'text_1')), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('about-vrchat', 'text_2')), 1)
            ])
          ]),
          _createVNode(_component_LinkButton, {
            href: "https://hello.vrchat.com/",
            "is-external": true
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('about-vrchat', 'link')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ContentBox, { class: "content-box" }, {
        default: _withCtx(() => [
          _createVNode(_component_Heading, {
            class: "box-title",
            tag: "h2"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('about-resonite', 'title')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('about-resonite', 'text_1')), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('about-resonite', 'text_2')), 1)
            ])
          ]),
          _createVNode(_component_LinkButton, {
            href: "https://resonite.com/",
            "is-external": true
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('about-resonite', 'link')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("section", _hoisted_24, [
      _createVNode(_component_ContentBox, { class: "content-box" }, {
        default: _withCtx(() => [
          _createVNode(_component_Heading, {
            class: "box-title",
            tag: "h2"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('about-jmof', 'title')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('about-jmof', 'text_1')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('about-jmof', 'text_2')), 1),
          _createVNode(_component_LinkButton, {
            href: "https://www.jmof.jp/",
            "is-external": true
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('about-jmof', 'link')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ], 64))
}